/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentCouponHistoryViewModel } from "../types/IndividualPaymentCouponHistoryViewModel.ts";

export const individualPaymentCouponHistoryViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  couponName: z.string().nullish(),
  discountPercentage: z.number().nullish(),
  discountValue: z.number().nullish(),
  creationJustification: z.string().nullish(),
  deleteJustification: z.string().nullish(),
  userNameCreator: z.string().nullish(),
  userNameDeleter: z.string().nullish(),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<IndividualPaymentCouponHistoryViewModel>;
